'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialsApi = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRIAL_ENDPOINT_BASE = 'trials/v1/hub-trials';

var _cachedAvailable = void 0;
var _cachedTrials = void 0;
var TrialsApi = exports.TrialsApi = {
  getTrialState: function getTrialState() {
    if (_cachedTrials) {
      return _cachedTrials;
    }

    _cachedTrials = _apiClient2.default.get(TRIAL_ENDPOINT_BASE + '?active=false');
    return _cachedTrials;
  },
  getAvailableTrials: function getAvailableTrials() {
    if (_cachedAvailable) {
      return _cachedAvailable;
    }

    _cachedAvailable = _apiClient2.default.get(TRIAL_ENDPOINT_BASE + '/available');
    return _cachedAvailable;
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/trialApi.js
// module id = 453
// module chunks = 3 4 5